import { MissingDatapointsCountBadge } from '@pages/User/components/MissingDatapointsCountBadge';
import type { ColumnHelper } from '@tanstack/react-table';
import { get } from 'lodash-es';

enum ShowContractValidOptions {
  Show = 'SHOW',
  Hide = 'HIDE',
}

const contractValidFilterOptions = [
  { value: ShowContractValidOptions.Show, label: 'With missing datapoints' },
  { value: ShowContractValidOptions.Hide, label: 'Without missing datapoints' },
];

export const contractValidAccessor = <T extends { contract_missing_data_count?: number; id: string }>(
  columnHelper: ColumnHelper<T>,
) =>
  columnHelper.accessor((entity) => entity.contract_missing_data_count, {
    id: 'missingDatapointsCount',
    header: 'Validation',
    cell: (cellContext) => (
      <MissingDatapointsCountBadge count={cellContext.getValue()} id={cellContext.row.original.id} />
    ),
    sortUndefined: 'last',
    meta: {
      filter: {
        label: 'Contract valid',
        placeholder: 'Missing datapoints',
        isSingleSelection: true,
        optionsMapping: contractValidFilterOptions,
        order: Number.MAX_SAFE_INTEGER,
      },
      headingCellClassName: '2xl:w-24',
    },
    filterFn: (row, _, selected) => {
      const contractMissingDataCount = get(row.original, 'contract_missing_data_count');
      if (selected === ShowContractValidOptions.Show) {
        const result = contractMissingDataCount !== undefined && contractMissingDataCount >= 1;
        return result ?? false;
      }

      if (selected === ShowContractValidOptions.Hide) {
        const result = contractMissingDataCount === undefined || contractMissingDataCount < 1;
        return result ?? false;
      }
      return true;
    },
  });
